import { Spinner } from '@fukuri-admins/ui/common';
import clsx from 'clsx';
import { Suspense } from 'react';
import { IS_STRESS_CHECK_IMPLEMENTER_BUILD } from '~/constants';
import { ClientSideMenu } from '~/features/ClientSideMenu';
import { StressAssessmentList } from '~/features/StressAssessmentList';
import { StressAssessmentScheduleAlert } from '~/features/StressAssessmentScheduleAlert';
import { StressAssessmentScheduleNotificationBanner } from '~/features/StressAssessmentScheduleNotificationBanner';
import { StressAssessmentHeader } from '~/ui/domain/stress-assessment/StressAssessmentHeader';
import styles from './styles.module.scss';

export const Screen: React.FC = () => {
  return (
    <div
      className={clsx(styles.screen, {
        [styles.NoSideMenu]: IS_STRESS_CHECK_IMPLEMENTER_BUILD,
      })}
    >
      {!IS_STRESS_CHECK_IMPLEMENTER_BUILD && <ClientSideMenu />}
      <div className={styles.content}>
        <StressAssessmentHeader showLogoutButton={IS_STRESS_CHECK_IMPLEMENTER_BUILD} />
        {!IS_STRESS_CHECK_IMPLEMENTER_BUILD && (
          <div className={styles.ScheduleAlertWrapper}>
            <Suspense fallback={<Spinner />}>
              <StressAssessmentScheduleAlert />
            </Suspense>
          </div>
        )}
        <Suspense fallback={<Spinner />}>
          <StressAssessmentList />
        </Suspense>
      </div>
      {!IS_STRESS_CHECK_IMPLEMENTER_BUILD && (
        <div className={styles.BannerWrapper}>
          <Suspense fallback={null}>
            <StressAssessmentScheduleNotificationBanner />
          </Suspense>
        </div>
      )}
    </div>
  );
};
